import { GraphQLClient, gql } from 'graphql-request';
import type { DealerData } from '../interfaces/header-components.interfaces';

const QUERY_BY_DEALER_ID = gql`
  query Dealer($dealerId: String!) {
    dealerById(dealerId: $dealerId) {
      name
      displayName
      url
      additionalData {
        displayName
      }
      dealerId
      services
      address
      phone
      openingHours {
        openingHoursFormatted
        openingHoursNote
        departments {
          id
          departmentName
          departmentOpeningHoursNote
          openingHours {
            id
            open
            timeRanges {
              openTime
              closeTime
            }
          }
        }
      }
    }
  }
`;

const metaValues: any = {};
export const getMetaContent = (dom: Element, metaName: string): string => {
  if (!metaValues[metaName] || dom !== metaValues[metaName].dom) {
    const metatag = dom.querySelector(`meta[name=${metaName}]`);
    metaValues[metaName] = {
      dom,
      value: metatag?.getAttribute('content') || '',
    };
  }
  return metaValues[metaName].value;
};

export async function getDealerData(
  endpoint: string | undefined,
  dealerId: string | undefined,
): Promise<DealerData | undefined> {
  let client;

  if (__DEBUG__ && !dealerId) {
    console.warn('[nemo-header|dealer-data] no Dealer ID found');
  }

  if (endpoint !== undefined) {
    client = new GraphQLClient(endpoint, {
      headers: {
        'apollographql-client-name': 'fa-nemo-header',
        'apollographql-client-version': process.env.npm_package_version ?? '',
      },
    });
  } else if (__DEBUG__) {
    console.warn('[nemo-header|dealer-data] no omnigraph endpoint provided');
  }

  return dealerId && client
    ? client.request(
        QUERY_BY_DEALER_ID,
        {
          dealerId,
        },
        { accept: 'application/json' },
      )
    : undefined;
}
